import { z } from 'zod';
import { CandidateOpportunitiesConst } from '@axiom/const';
import { SchemaTimestamp, ZodArrayToEnum } from '@axiom/types';

import { ZodCandidateOpportunityCandidateStatuses } from './candidate-opportunities-candidate-statuses';
import { CandidateSchema } from './candidate';

const CandidateRejectionLossCodes = Object.values(
  CandidateOpportunitiesConst.CandidateRejectionLossCodes
);
export const MLRecommendationSchema = z.object({
  id: z.string().uuid(),
  candidate: CandidateSchema,
  candidateId: z.string().uuid(),
  candidateOpportunityId: z.string().uuid().nullable(),
  candidateStatus: ZodCandidateOpportunityCandidateStatuses,
  createdAt: SchemaTimestamp,
  isCrossFulfilled: z.boolean(),
  mlLossCode: z.enum(ZodArrayToEnum(CandidateRejectionLossCodes)).nullable(),
  opportunityId: z.string().uuid(),
  previousCandidateStatus: ZodCandidateOpportunityCandidateStatuses.nullable(),
  updatedAt: SchemaTimestamp.nullable(),
  updatedBy: z.string().uuid().nullable(),
});

export type MLRecommendation = z.infer<typeof MLRecommendationSchema>;
